import OrdersList from '@/components/OrdersModule/OrdersTabs/OrdersList'
import { FC } from 'react'

const Page: FC = () => {
    return <OrdersList />
}

export default Page
